import s from './FreeWrite.module.sass';

import { Button, Checkbox, Form, FormItem, Header, ScrollView } from '$uikit';
import React, { FC, useState } from 'react';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { Truncate } from '$shared/components';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { UserModel } from '$store/models';
import { mainActions } from '$store/main';
import { goBack } from '$navigation/helper';

export const FreeWrite: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const user = useCurrentUserInfo();
  const [value, setValue] = useState(user.allowWriteForFree);

  const handleSave = () => {
    dispatch(toastActions.setToastLoading());
    Api.post<
      {
        enabled: boolean;
      },
      {
        user: UserModel;
      }
    >('/profile/free_write', {
      enabled: value,
    })
      .then((data) => {
        dispatch(mainActions.setUser(data.user));
        dispatch(toastActions.setToastSuccess());
        goBack();
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  };

  return (
    <>
      <Header showBackButton>{t('free_write_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem>
            <div className={s.infoMsg}>
              <Truncate text={t('free_write_info')} />
            </div>
          </FormItem>
          <FormItem>
            <Checkbox
              checked={value}
              onClick={() => {
                setValue(!value);
              }}
            >
              {t('free_write_toggle')}
            </Checkbox>
          </FormItem>
          <FormItem>
            <Button onClick={handleSave}>{t('save')}</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
